export interface RecognitionContext {
    projectId: number;
    floorId: number;
    isSampleImage: boolean;
}

export enum ChecklistKey {
    MEASUREMENT = 'measurement',
    OUTER_WALL = 'outerWall',
    ROOMS = 'rooms',
    DOORS = 'doors',
    WINDOWS = 'windows',
}

export const CHECKLIST_ORDER: ChecklistKey[] = [
    ChecklistKey.MEASUREMENT,
    ChecklistKey.OUTER_WALL,
    ChecklistKey.ROOMS,
    ChecklistKey.DOORS,
    ChecklistKey.WINDOWS,
];

export enum ChecklistItemStatus {
    IN_PROGRESS = 'in-progress',
    SUCCESS = 'success',
    FAILED = 'failed',
}

export type ChecklistState = Record<ChecklistKey, ChecklistItemStatus>;

export enum RecognitionOutcome {
    MEASUREMENT_DETECTED = 'measurementDetected',
    NO_MEASUREMENT = 'noMeasurement',
    UNSUCCESSFUL = 'unsuccessful',
    LIMIT_EXCEEDED = 'limitExceeded',
}

export interface RecognitionResult {
    outcome: RecognitionOutcome;
    roomsDetected: boolean;
}

export function buildInitialChecklist(): ChecklistState {
    return {
        [ChecklistKey.MEASUREMENT]: ChecklistItemStatus.IN_PROGRESS,
        [ChecklistKey.OUTER_WALL]: ChecklistItemStatus.IN_PROGRESS,
        [ChecklistKey.ROOMS]: ChecklistItemStatus.IN_PROGRESS,
        [ChecklistKey.DOORS]: ChecklistItemStatus.IN_PROGRESS,
        [ChecklistKey.WINDOWS]: ChecklistItemStatus.IN_PROGRESS,
    };
}
